import { Stepper } from "@shared/components/Stepper";
import { useState } from "react";
import BillSelectionStep from "./BillSelectionStep";
import CorrectionTypes from "./CorrectionTypes";
import CorrectionDetails from "./CorrectionDetails";
import { ImpactAnalysis } from "./ImpactAnalysis";
import { ApprovalStep } from "./ApprovalStep";

export const BillCorrectionForm = () => {
  const handleComplete = (
    allStepData: any,
    completedSteps: number[],
    skippedSteps: number[],
  ) => {
    console.log("Workflow completed:", allStepData);
    // Handle final submission
  };

  const stepperSteps = [
    {
      id: "bill-selection",
      description: "Bill Search",
      component: <BillSelectionStep />,
      slug: "bill-selection",
      infoDescription: "",
    },
    {
      id: "correction-types",
      description: "Correction Types",
      component: <CorrectionTypes />,
      slug: "correction-types",
    },
    {
      id: "correction-details",
      description: "Correction Details",
      component: <CorrectionDetails />,
      slug: "correction-details",
    },
    {
      id: "impact-analysis",
      description: "Impact Analysis",
      component: <ImpactAnalysis />,
      slug: "impact-analysis",
    },
    {
      id: "approve-bill",
      description: "Approval",
      component: <ApprovalStep />,
      slug: "approve-bill",
    },
  ];

  return (
    <div>
      <div className="flex items-center justify-between border-b">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Bill Correction</h1>
          <p className="text-sm text-gray-600 mt-1">
            {/* Create and manage billing cycles using this streamlined workflow */}
          </p>
        </div>
      </div>

      {/* Stepper Content */}
      <div className="flex-1 overflow-y-auto p-4">
        <Stepper
          steps={stepperSteps}
          onComplete={handleComplete}
          autoSave={true}
          persistProgress={true}
          storageKey="bill-correction"
          allowSkip={false}
          enableRouting={true}
          className="w-full"
          allowStepClick={false}
          enableDraftMode={true}
          showDraftResume={true}
          onStepChange={undefined}
          onValidation={undefined}
          onStepSave={undefined}
        />
      </div>
    </div>
  );
};
